import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const PhonePeStatus = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [details, setDetails] = useState({});
  const txnId = searchParams.get("txnId");
  const bookingId = searchParams.get("bookingId");

  useEffect(() => {
    if (txnId && bookingId) {
      fetch(
        "https://letsenjoytourplanners.com/letsenjoy_api/paymentstatus.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            txnid: txnId,
            bookingId: bookingId,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data && data.status === "success") {
            setStatus("success");
            setDetails(data.data || {});
          } else {
            setStatus("failed");
            setDetails({
              message:
                data?.message || "Payment failed or transaction not found.",
            });
          }
        })
        .catch((err) => {
          console.error("Error fetching status:", err);
          setStatus("error");
          setDetails({
            message: "Something went wrong. Please try again later.",
          });
        });
    } else {
      setStatus("error");
      setDetails({ message: "Missing transaction or booking ID in URL." });
    }
  }, [txnId, bookingId]);

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    background: "linear-gradient(to right, #667eea, #764ba2)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: "20px",
  };

  const cardStyle = {
    backgroundColor: "#fff",
    padding: "40px 30px",
    borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
    maxWidth: "480px",
    width: "100%",
    textAlign: "center",
  };

  const iconStyle = {
    fontSize: "48px",
    marginBottom: "20px",
  };

  const successStyle = {
    color: "#28a745",
  };

  const failStyle = {
    color: "#dc3545",
  };

  const labelStyle = {
    fontWeight: "600",
    color: "#555",
  };

  const valueStyle = {
    marginBottom: "15px",
    fontSize: "18px",
    color: "#222",
  };

  const loadingStyle = {
    fontSize: "18px",
    color: "#333",
  };

  const buttonStyle = {
    marginTop: "25px",
    padding: "10px 20px",
    fontSize: "16px",
    borderRadius: "8px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    transition: "background 0.3s",
  };

  const handleRedirect = () => {
    window.location.href = "https://letsenjoytourplanners.com/#/loginsubmit";
  };

  if (status === "loading") {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={loadingStyle}>🔄 Checking payment status...</div>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        {details.payment_status === "SUCCESS" ? (
          <div>
            <div style={{ ...iconStyle, ...successStyle }}>✅</div>
            <h2 style={successStyle}>Payment Successful</h2>
            <p style={valueStyle}>
              <span style={labelStyle}>Transaction ID:</span>{" "}
              {details.transaction_id || "N/A"}
            </p>
            <p style={valueStyle}>
              <span style={labelStyle}>Amount:</span> ₹
              {details.amount || "0.00"}
            </p>
            <p style={valueStyle}>
              <span style={labelStyle}>Status:</span>{" "}
              {details.payment_status || "Success"}
            </p>
          </div>
        ) : (
          <div>
            <div style={{ ...iconStyle, ...failStyle }}>❌</div>
            <h2 style={failStyle}>
              {details.payment_status === "FAILED" ? "Payment Failed" : "Error"}
            </h2>
            <p style={valueStyle}>{details.message}</p>
          </div>
        )}

        <button style={buttonStyle} onClick={handleRedirect}>
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default PhonePeStatus;
